module.exports = __webpack_public_path__ + "img/pt_qczj.dfc483d8.png";